<template>
  <div
    class="data-table-show-off"
    @click="showOff"
  >
    <div v-if="isLoading">
      <spinner class="small" />
    </div>

    <div v-else>
      <svg-loader
        src="/static/images/icon-caret.svg"
        class="data-table-show-off-caret"
        :style="{
          transform: isOpen ? 'rotate(180deg)' : undefined
        }"
      />
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

export default {
  name: 'DataShowOff',
  components: {
    Spinner
  },
  props: {
    isOpen: Boolean,
    isLoading: Boolean
  },
  methods: {
    showOff() {
      this.$emit('show-off')
    }
  }
}
</script>

<style lang="scss" scoped>
.data-table-show-off {
  cursor: pointer;
  min-height: 3em;
  display: flex;
  align-items: center;
  justify-content: center;

  &-caret {
    transition: transform 0.3s;
  }

  .md-icon {
    width: 0.5rem;
    height: 0.5rem;
    min-width: auto;
    min-height: auto;
  }
}
</style>
